var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Form } from 'antd';
import createFromFactory from '../base/createFormFactory';
// 对 antd 的 FormItem 做一层转化，将 help 赋值给 antd.FormItem 的 extra，error 信息赋值给 antd.FormItem 的 help
function FieldWrapper(props) {
    return React.createElement(Form.Item, __assign({}, props, { extra: props.help, help: props.error }));
}
export default createFromFactory(FieldWrapper);
